import { Dicionario } from "./dicionario";

export class Login {
    configuracao_atual: any;
    conta: any;
    expiresInHours: number;
    gru_configuracao: any;
    grupopermissoes: any;
    token: string;
    sessionExpired: boolean = false;
    idcliente_remote: any = null;
    cli_modoconexao: any = null;
    cli_conexao: any = null;


    constructor(responseAPI: any, idcliente_remote, cli_modoconexao, cli_conexao) {

        this.conta = responseAPI.conta;
        this.expiresInHours = responseAPI.expiresInHours;
        this.token = responseAPI.token;
        this.idcliente_remote = idcliente_remote;
        this.cli_modoconexao = cli_modoconexao;
        this.cli_conexao = cli_conexao;

        try {
            this.configuracao_atual = JSON.parse(responseAPI.conta.csi_configuracao);
        } catch (error) {
            console.log('csi_configuracao: ' + error);
        }

        try {
            this.grupopermissoes = JSON.parse(responseAPI.conta.json_grupo_permissao);

        } catch (error) {
            console.log('json_grupo_permissao: ' + error);
        }

        try {
            this.gru_configuracao = JSON.parse(responseAPI.conta.gru_configuracao);
        } catch (error) {
            console.log('gru_configuracao: ' + error);
        }

        try {

            if (this.conta.con_empresas) {
                // convert to array of int        
                this.conta.con_empresas = this.conta.con_empresas.split(',').map(function (item) {
                    return parseInt(item, 10);
                });
            }

        } catch (error) {
            console.log('Class Login: ' + error);
        }

    }

    get nomeCliente() {
        return this.conta.cli_nome;
    }

    get Qrcodemensagem() {
        return this.conta.cli_qrcodemensagem;
    }

    get idCliente() {
        return this.conta.fk_idcliente;
    }

    get idClienteRemote() {
        return this.conta.cli_id;
    }

    get idConta() {
        return this.conta.pk_idconta;
    }

    get idEmpresa() {
        return this.conta.fk_idempresa;
    }

    get empresas() {
        return this.conta.con_empresas;
    }

    get login() {
        return this.conta.con_login;
    }

    get nomeConta() {
        return this.conta.con_usuario;
    }

    temPermissao(dicionario, crud): boolean {

        var retorno = false;

        if (dicionario && this.grupopermissoes) {

            this.grupopermissoes.forEach(gp => {

                if (gp.fk_iddicionario == dicionario && gp.gpe_acesso && gp.gpe_acesso.indexOf(crud) >= 0) {
                    retorno = true;
                    return;
                }

            });
        }

        return retorno;

    }

    getConfiguracaoPorPefilPessoa(perfil): any {

        let retorno = null;

        switch (perfil) {
            case 1:
                // visitante
                retorno = this.configuracao_atual.visitante;
                break;
            case 2:
                // Funcionario
                retorno = this.configuracao_atual.funcionario;
                break;
            case 3:
                // Morador                
                retorno = this.configuracao_atual.morador;
                break;
            case 4:
                // Aluno                
                retorno = this.configuracao_atual.aluno;
                break;
            default:
                break;
        }

        return retorno;
    }


}
